import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";

const slug = (w) => w.replace(/[^a-z0-9]+/g, "-");

// BATCH 4 — a truck's keywords. The AI SUGGESTS them on a read already paid for; one joins the truck only when a
// person taps it, and the Vehicles box then finds the truck by it. Every tap can be taken back.
export function TruckKeywords({ donorId, keywords, suggestions, canEdit, testid = "truck-keywords" }) {
  const [kw, setKw] = useState({ keywords: keywords || [], keyword_suggestions: suggestions || [] });
  useEffect(() => { setKw({ keywords: keywords || [], keyword_suggestions: suggestions || [] }); }, [keywords, suggestions]);
  const [busy, setBusy] = useState("");
  const send = async (body, word) => {
    setBusy(word);
    try {
      const { data } = await api.post(`/donors/${donorId}/keywords`, body);
      setKw(data);
      if (body.add) toast.success(`Keyword “${word}” added`, { action: { label: "Undo", onClick: () => send({ remove: word }, word) } });
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(""); }
  };
  return (
    <div data-testid={testid} className="space-y-2">
      <div className="flex flex-wrap items-center gap-1.5">
        <span className="text-xs font-semibold text-slate-500 mr-1">Keywords:</span>
        {kw.keywords.length === 0 && <span data-testid={`${testid}-none`} className="text-xs text-slate-400">none yet</span>}
        {kw.keywords.map((w) => (
          <span key={w} data-testid={`${testid}-kw-${slug(w)}`} className="inline-flex items-center gap-1 rounded-full bg-slate-800 text-white text-xs px-2.5 h-7">
            {w}
            {canEdit && <button type="button" aria-label={`Remove ${w}`} data-testid={`${testid}-remove-${slug(w)}`} disabled={!!busy}
              onClick={() => send({ remove: w }, w)} className="opacity-70 hover:opacity-100"><X className="w-3 h-3" /></button>}
          </span>
        ))}
      </div>
      {kw.keyword_suggestions.length > 0 && (
        <div className="flex flex-wrap items-center gap-1.5" data-testid={`${testid}-suggestions`}>
          <span className="text-xs font-semibold text-[#C76714] mr-1">AI suggests{canEdit ? " — tap to add:" : ":"}</span>
          {kw.keyword_suggestions.map((w) => (
            <span key={w} className="inline-flex items-center rounded-full border border-dashed border-[#E0781A] bg-orange-50 text-xs">
              <button type="button" data-testid={`${testid}-add-${slug(w)}`} disabled={!canEdit || !!busy} onClick={() => send({ add: w }, w)}
                className="inline-flex items-center gap-1 px-2.5 h-7 text-[#9a3412] disabled:cursor-default">
                {canEdit && <Plus className="w-3 h-3" />}{w}
              </button>
              {canEdit && <button type="button" aria-label={`Not this one: ${w}`} data-testid={`${testid}-dismiss-${slug(w)}`} disabled={!!busy}
                onClick={() => send({ dismiss: w }, w)} className="pr-2 text-[#C76714]/70 hover:text-[#C76714]"><X className="w-3 h-3" /></button>}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
